import config from '@/config'
import parseISODate from '../../functions/parseISODate'

const ALERT_TITLES = {
  [config.sessionStatus.COACH_ACCEPTED]: 'Einladung wurde an den Coachee gesendet.',
  [config.sessionStatus.COACHEE_ACCEPTED]: 'Einladung wurde an den Coach gesendet',
  [config.sessionStatus.BOTH_ACCEPTED]: 'Sitzung wurde bestätigt.',
  [config.sessionStatus.REJECTED]: 'Sitzung hat nicht stattgefunden.'
}

const ALERT_TYPES = {
  [config.sessionStatus.BOTH_ACCEPTED]: 'success',
  [config.sessionStatus.REJECTED]: 'error'
}

const ACCEPTANCE = {
  new: 0,
  accepted: 1,
  rejected: 2,
  pending: 3
}

/**
 * Convert data from session API to internal format
 * @param {Object} session Session data
 * @param {Number} session.id Session ID
 * @param {Number} session.coaching Coaching ID
 * @param {0|1|2|3} session.acceptance_coach Coach acceptance status
 * @param {0|1|2|3} session.acceptance_coachee Coachee acceptance status
 * @param {0|1|2|3} session.acceptance Combined acceptance status
 * @param {String} session.date Date
 * @param {String} session.start Start time
 * @param {String} session.end End time
 * @param {String} session.location Location
 * @param {String} session.comment Comment
 * @returns {Object} Converted session data
 */
export default function (session) {
  let status = config.sessionStatus.NEW

  if (
    session.acceptance_coach === ACCEPTANCE.accepted &&
    session.acceptance_coachee === ACCEPTANCE.pending
  ) {
    status = config.sessionStatus.COACH_ACCEPTED
  }

  if (
    session.acceptance_coach === ACCEPTANCE.pending &&
    session.acceptance_coachee === ACCEPTANCE.accepted
  ) {
    status = config.sessionStatus.COACHEE_ACCEPTED
  }

  if (session.acceptance === ACCEPTANCE.accepted) {
    status = config.sessionStatus.BOTH_ACCEPTED
  }

  if (session.acceptance === ACCEPTANCE.rejected) {
    status = config.sessionStatus.REJECTED
  }

  const timeStart = parseISODate(session.date, session.start)
  const timeEnd = parseISODate(session.date, session.end)

  return {
    id: session.id,
    coaching: session.coaching,
    status,
    alert: {
      title: ALERT_TITLES[status],
      type: ALERT_TYPES[status]
    },
    date: new Date(session.date),
    timeStart,
    timeEnd,
    duration: timeEnd - timeStart,
    location: session.location,
    comment: session.comment
  }
}
